module.exports = __webpack_public_path__ + "static/media/jimmy-jo.ad6cb792.jpg";